module.exports = __webpack_public_path__ + "img/train4.99cf4498.png";